import React, { useState } from "react";
import { useSeo } from "../useSeo";
import { trackEvent } from "../trackEvent";
import { API_BASE } from "../../api/client";

const EMPTY_FORM = {
  name: "",
  whatsapp: "",
  email: "",
  city: "",
  neighborhood: "",
  notes: ""
};

export default function CadastroVisitante() {
  useSeo({
    title: "Cadastro de visitante | Igreja Batista Mosaico",
    description: "Nos visitou? Deixe seu contato pra gente te receber direito e acompanhar sua caminhada na Mosaico.",
    path: "/cadastro/visitante"
  });

  const [form, setForm] = useState(EMPTY_FORM);
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [errorMsg, setErrorMsg] = useState("");

  const update = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  async function handleSubmit(event) {
    event.preventDefault();
    trackEvent("form_submit", { form_name: "cadastro_visitante" });

    setStatus("sending");
    setErrorMsg("");
    try {
      const res = await fetch(`${API_BASE}/public/visitante-signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...form,
          name: form.name.trim()
        })
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data?.error || "Não foi possível enviar seu cadastro agora.");
      }
      setStatus("sent");
      setForm(EMPTY_FORM);
    } catch (err) {
      setStatus("error");
      setErrorMsg(err?.message || "Não foi possível enviar seu cadastro agora. Tente novamente em instantes.");
    }
  }

  const disabled = status === "sending";

  return (
    <>
      <div className="section-head" style={{ marginTop: 34 }}>
        <p className="eyebrow">Cadastro de visitante</p>
        <h1>Que bom que você nos visitou!</h1>
        <p>Deixe seu contato abaixo pra gente te receber direito e acompanhar sua caminhada com a gente.</p>
      </div>

      <div className="card" style={{ maxWidth: 560 }}>
        {status === "sent" && (
          <div className="confirm-banner">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
            Recebemos seu contato -- alguém da nossa equipe de acolhimento vai falar com você em breve. Que bom ter você por aqui!
          </div>
        )}
        {status === "error" && (
          <div className="confirm-banner confirm-banner-error">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 8v5M12 16h.01" /></svg>
            {errorMsg}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-row"><label>Nome completo <span className="form-required">*</span></label><input type="text" required placeholder="Seu nome completo" value={form.name} onChange={(e) => update("name", e.target.value)} disabled={disabled} /></div>
          <div className="form-row"><label>WhatsApp <span className="form-required">*</span></label><input type="tel" required placeholder="(11) 90000-0000" value={form.whatsapp} onChange={(e) => update("whatsapp", e.target.value)} disabled={disabled} /></div>
          <div className="form-row"><label>E-mail <span className="form-optional">(opcional)</span></label><input type="email" placeholder="voce@email.com" value={form.email} onChange={(e) => update("email", e.target.value)} disabled={disabled} /></div>
          <div className="grid grid-2">
            <div className="form-row"><label>Cidade <span className="form-optional">(opcional)</span></label><input type="text" value={form.city} onChange={(e) => update("city", e.target.value)} disabled={disabled} /></div>
            <div className="form-row"><label>Bairro <span className="form-optional">(opcional)</span></label><input type="text" value={form.neighborhood} onChange={(e) => update("neighborhood", e.target.value)} disabled={disabled} /></div>
          </div>
          <div className="form-row"><label>Alguma observação? <span className="form-optional">(opcional)</span></label><textarea rows="3" placeholder="Como nos conheceu, quem te convidou, algum pedido..." value={form.notes} onChange={(e) => update("notes", e.target.value)} disabled={disabled} /></div>

          <button className="submit-btn" type="submit" disabled={disabled}>{disabled ? "Enviando…" : "Enviar cadastro"}</button>
          <p className="form-note">Seu contato fica com a equipe de acolhimento, que entra em contato em breve.</p>
        </form>
      </div>
    </>
  );
}
